import React from "react";
import Header from "../Summidence/Header";
import Unlikely from "../Summidence/Unlikely";
import Getyourcopy from "../Summidence/Getyourcopy";
import Jason from "../Summidence/Jason";
import Current from "../Summidence/Current";
import Testimonials from "../Summidence/Testimonials";
import Contantus from "../Summidence/Contantus";
import YourLeadership from "../Summidence/YourLeadership";
import BeyondPublic from "../Summidence/BeyondPublic";

const Summidence = () => {
  return (
    <div>
      <Header />
      <Unlikely />
      <Getyourcopy />
      <Jason />
      <YourLeadership />
      {/* <BeyondPublic /> */}
      <Current />
      {/* <Testimonials /> */}
      {/* <Contantus /> */}
    </div>
  );
};

export default Summidence;
